{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} cuộc hội thoại đã được chọn",
    "AGENT_SELECT_LABEL": "Chọn thành viên",
    "ASSIGN_CONFIRMATION_LABEL": "Bạn có chắc chắn để chỉ định {conversationCount} {conversationLabel} tới",
    "UNASSIGN_CONFIRMATION_LABEL": "Bạn có chắc chắn hủy chỉ định {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Trở về",
    "ASSIGN_LABEL": "Gán",
    "YES": "Có",
    "SEARCH_INPUT_PLACEHOLDER": "Tìm kiếm",
    "ASSIGN_AGENT_TOOLTIP": "Gán tổng đài viên",
    "ASSIGN_TEAM_TOOLTIP": "Gán nhóm",
    "ASSIGN_SUCCESFUL": "Cuộc hội thoại đã được phân công thành công.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Cuộc hội thoại đã được giải quyết thành công.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Chỉ những cuộc hội thoại hiển thị trên trang này mới có thể được chọn.",
    "AGENT_LIST_LOADING": "Đang tải điện thoại viên",
    "UPDATE": {
      "CHANGE_STATUS": "Thay đổi trạng thái",
      "SNOOZE_UNTIL": "Báo lại",
      "UPDATE_SUCCESFUL": "Đã cập nhật trạng thái cuộc hội thoại thành công.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "Không tìm thấy nhãn nào cho",
      "ASSIGN_SELECTED_LABELS": "Gán các nhãn đã chọn",
      "ASSIGN_SUCCESFUL": "Các nhãn được gán thành công.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Chọn nhóm",
      "NONE": "Không có",
      "NO_TEAMS_AVAILABLE": "Chưa có nhóm nào được thêm vào tài khoản này.",
      "ASSIGN_SELECTED_TEAMS": "Chỉ định nhóm đã chọn.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Gộp các cuộc hội thoại",
      "TITLE": "Gộp Cuộc hội thoại",
      "DESCRIPTION": "Chọn một cuộc hội thoại đích. Tất cả các cuộc hội thoại được chọn khác sẽ được gộp vào đó — tin nhắn của chúng sẽ được chuyển đến cuộc hội thoại đích và các cuộc hội thoại nguồn sẽ bị xóa.",
      "TARGET_LABEL": "Cuộc hội thoại đích (sẽ được giữ lại)",
      "SOURCES_LABEL": "Cuộc hội thoại nguồn (sẽ bị xóa)",
      "SELECT_TARGET": "Chọn một cuộc hội thoại làm đích gộp",
      "WARNING": "Cảnh báo: Hành động này không thể hoàn tác. Tin nhắn từ tất cả các cuộc hội thoại nguồn sẽ được chuyển đến cuộc hội thoại đích và các cuộc hội thoại nguồn sẽ bị xóa vĩnh viễn.",
      "SUBMIT": "Gộp Cuộc hội thoại",
      "CANCEL": "Huỷ",
      "SUCCESS_MESSAGE": "Đã gộp các cuộc hội thoại thành công",
      "ERROR_MESSAGE": "Không thể gộp các cuộc hội thoại. Vui lòng thử lại.",
      "CONFIRM": {
        "TITLE": "Xác nhận Gộp",
        "DESCRIPTION": "Bạn có chắc chắn muốn gộp {sourceCount} cuộc hội thoại vào #{targetId} không? Hành động này không thể hoàn tác.",
        "YES": "Có, Gộp",
        "CANCEL": "Huỷ"
      }
    }
  }
}
